import { SET_FORM_DATA } from "../staffInfoReducer";


const getDefaultYear = () => {
    const now = new Date()
    return now.getMonth() < 7 ? now.getFullYear() : now.getFullYear() + 1
}

const initialState = {
    year: getDefaultYear(),
    idOrg: "0",
    school: "1",
};

export const formReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_FORM_DATA:
            return action.payload;
        default:
            return state;
    }
};
